/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEdit} from '@fortawesome/pro-duotone-svg-icons';

const GradesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faEdit} {...props} />
);

export default GradesIcon;
